export interface VideoDetails {
  video: string;
  posterUrl: string;
  name?: string;
  city?: string;
  comment?: string;
}

export const ABOUT_PAGE_VIDEOS = [
  {
    video: "https://media.brandclub.com/brandclub/media/video_david.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_david.png",
    name: "David R.",
    city: "Minneapolis, MN",
    comment: `“I can now earn cash back for purchases at Amazon, Walmart and Target.”`,
  },
  {
    video: "https://media.brandclub.com/brandclub/media/video_jessica.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_jessica.png",
    name: "Jessica P.",
    city: "Dallas, TX",
    comment: `“I can earn cash back whenever I shop online or in my favorite stores.”`,
  },
  {
    video: "https://media.brandclub.com/brandclub/media/video_emma.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_emma.png",
    name: "Emma S.",
    city: "Phoenix, AZ",
    comment: `“Brandclub has an amazing affiliate program where I can earn up to 20% commission.”`,
  },

  {
    video: "https://media.brandclub.com/brandclub/media/video_angela.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_angela.png",
    name: "Angela W.",
    city: "Chicago, Il.",
    comment: `“Brandclub allows me to earn cash back for the items that are always in my shopping cart.”`,
  },
  {
    video: "https://media.brandclub.com/brandclub/media/video_marcus.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_marcus.png",
    name: "Marcus H.",
    city: "Boston, MA",
    comment: `“I can easily compare prices across Chewy, Amazon and other retailers.”`,
  },
] satisfies VideoDetails[];

export const ABOUT_PAGE_HEADER_VIDEOS = [
  {
    video: "https://media.brandclub.com/brandclub/media/home_head.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/home_head.png",
  },
  {
    video: "https://media.brandclub.com/brandclub/media/video_david.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_david.png",
  },
  {
    video: "https://media.brandclub.com/brandclub/media/video_jessica.mp4",
    posterUrl:
      "https://media.brandclub.com/brandclub/media/cover/video_jessica.png",
  },
] satisfies VideoDetails[];